import { queryMailAddress } from "Constants/constants";
import "./style.css";

const SendMessage = () => {
  return (
    <div className="send-message-main-container p-4">
      <h2 className="header-text">We're Here To Help!</h2>
      <p className="description">
        If you have any questions or need assistance, our team is here to
        support you. Reach out to us via email at{" "}
        <a
          href={`mailto:${queryMailAddress}`}
          style={{ textDecoration: "underline" }}
        >
          Onegrad Support
        </a>
        .
      </p>
    </div>
  );
};

export default SendMessage;
